import { FlexColumn } from '@/atoms/FlexContainers'
import { Text } from '@/atoms/Text'
import { PreSaleFaqs } from '../components/PreSaleFaqs'

export const PresalesFAQsTab = () => (
  <FlexColumn className="container mx-auto mb-16 gap-4 px-4 pt-16 md:gap-4 md:px-16 md:pb-32 lg:px-24">
    <Text color="homestead-primary-blue" className="homestead-title-lg md:homestead-title-xl uppercase">
      faqs
    </Text>
    <PreSaleFaqs />
  </FlexColumn>
)
